import { useState, useRef, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { ReactComponent as HiChevronDown } from "../../assets/MainPage/addBlock/countDown/arrow-down.svg";
import {ReactComponent as CalendarIcon} from "../../assets/MainPage/addBlock/countDown/calendar.svg";
import useSettings from "../../hooks/useSettings";

const DatePicker = ({ onChange, value, placeholder, className }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showDatePicker, setShowDatePicker] = useState(value ? false : true);
  const inputRef = useRef(null);
  const { themeDirection } = useSettings();

  useEffect(() => {
    if(value){
      setSelectedDate(value);
    }
  }, [value])

  const formatDate = (date) => {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    const formatter = new Intl.DateTimeFormat("en-US", options);
    const parts = formatter.formatToParts(date);
    const reorderedParts = [parts[2], parts[0], parts[4]];
    return reorderedParts.map((part) => part.value).join("/");
  };

  const handleChange = (date) => {
    setSelectedDate(date);
    onChange(date);
    setShowDatePicker(false);
  };

  const handlePrevMonth = () => {
    const newDate = new Date(selectedDate);
    newDate.setMonth(newDate.getMonth() - 1);
    setSelectedDate(newDate);
  };

  const handleNextMonth = () => {
    const newDate = new Date(selectedDate);
    newDate.setMonth(newDate.getMonth() + 1);
    setSelectedDate(newDate);
  };

  const handleInputClick = () => {
    setShowDatePicker(true);
  };

  const handleDatePickerClick = () => {
    inputRef.current.focus();
  };

  const renderDatePicker = () => {
    const days = ["S", "M", "T", "W", "T", "F", "S"];
    const month = selectedDate.getMonth();
    const year = selectedDate.getFullYear();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const startDate = new Date(firstDay);
    startDate.setDate(startDate.getDate() - firstDay.getDay());
    const endDate = new Date(lastDay);
    endDate.setDate(endDate.getDate() + (6 - lastDay.getDay()));

    const dates = [];
    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      const date = new Date(currentDate);
      const isCurrentMonth = date.getMonth() === month;
      const className = `
        cursor-pointer text-center w-9 h-9 flex justify-center items-center p-1.5 rounded-full text-small2 ${
          isCurrentMonth ? "hover:bg-[#f7534a4a]" : "text-[#333333]"
        } ${
        formatDate(date) === formatDate(selectedDate)
          ? "bg-main_color text-white"
          : ""
      }
      `;
      dates.push(
        <div
          key={date}
          className={className}
          onClick={() => handleChange(date)}
        >
          <p> {date.getDate()} </p>
        </div>
      );
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return (
      <div
        className="w-full mt-[5px] z-10 bg-light_bg_v5 border border-light_bg_v4 rounded-lg p-[18px]"
        onClick={handleDatePickerClick}
      >
        <div className="flex justify-between mb-2.5 ">
          <div className=" text-small1_bold text-main_color">
            
            {`${new Intl.DateTimeFormat("en-US", {
              month: "long",
            }).format(selectedDate)}`}
          </div>
          <div className={`flex gap-2 items-center ${themeDirection === "rtl" ? "flex-row-reverse" : ""}`}>
            <button
            type="button"
              className="text-heading_color hover:text-gray-600 font-light text-md"
              onClick={handlePrevMonth}
            >
              <FaChevronLeft />
            </button>
            <button
            type="button"
              onClick={handleNextMonth}
              className="text-heading_color hover:text-gray-600 font-light text-md"
            >
              <FaChevronRight />
            </button>
          </div>
        </div>
        <div className="grid grid-cols-7 text-center gap-2 mt-4 mb-[12.5] pl-[4px] text-small2_b">
          
          {days.map((day, i) => (
            <p key={i}> {day} </p>
          ))}
        </div>
        <div className="grid grid-cols-7 gap-2 justify-items-center"> {dates} </div>
      </div>
    );
  };
  return (
    <div>
      <div className={`relative m-0 ${className} `}>
        <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex items-center">
          <CalendarIcon
            className="cursor-pointer"
            onClick={() => setShowDatePicker(!showDatePicker)}
           
          />
        </div>
        <input
          ref={inputRef}
          type="text"
          className="w-full text-heading_color text-small2 sm:text-small1 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] focus:outline-none focus:border-0 rounded-lg bg-light_bg_v4 "
          placeholder={placeholder}
          value={selectedDate === "Choose Date" ? "Choose Date" : formatDate(selectedDate)}
          onClick={handleInputClick}
          readOnly
        />
        <div
          onClick={() => setShowDatePicker(!showDatePicker)}
          className="text-2xl absolute end-0 inset-y-0 h-full sm:pe-[10px] pe-[16px] flex items-center font-semibold text-heading_color cursor-pointer"
        >
          
          <HiChevronDown />
        </div>
      </div>
      <div className=" flex justify-center">
        
        {showDatePicker && renderDatePicker()}
      </div>
    </div>
  );
};

export default DatePicker;
